import React from "react";
import AllStatistiqueBien from "./AllStatistiqueBien";
import { useSelector } from "react-redux";
import { Help } from "../../utils";

export default function BiensStatistiques({ typePeriodeFilter }) {
  const valueMoneyFormatter = (value) => `${Help.convertInMoney(value)}`;
  const datasetProprieteVenteMaison = useSelector(
    (state) => state.proprietesVenteMaisonStatistiqueFinance.bien_vente
  );
  const datasetProprieteVenteTerrain = useSelector(
    (state) => state.proprietesVenteTerrainStatistiqueFinance.terrain_en_vente
  );
  const datasetProprieteLocationMaison = useSelector(
    (state) => state.proprietesLocationMaisonStatistiqueFinance.bien_locations
  );

  const datasetProprieteLocationMaisonIndisponible = useSelector(
    (state) =>
      state.proprietesLocationMaisonStatistiqueFinance
        .biens_location_Indisponible
  );

  const datasetProprieteVenteMaisonIndisponible = useSelector(
    (state) =>
      state.proprietesVenteMaisonStatistiqueFinance.bien_vente_indisponible
  );

  const datasetProprieteVenteTerrainIndisponible = useSelector(
    (state) =>
      state.proprietesVenteTerrainStatistiqueFinance
        .terrain_en_vente_indisponible
  );

  console.log("datasetProprieteLocationMaison", datasetProprieteLocationMaison);
  console.log("typePeriodeFilter", typePeriodeFilter);
  return (
    <>
      {typePeriodeFilter === "Maison en location" && (
        <CompomentChildrenForStatistique
          dataSeries={[
            {
              dataKey: "maison_location",
              label: "Enregistrés",
              valueFormatter: valueMoneyFormatter,
            },
          ]}
          dataSeriesIndisponible={[
            {
              dataKey: "maison_location_indisponible",
              label: "Enregistrés",
              valueFormatter: valueMoneyFormatter,
            },
          ]}
          datasetIndisponible={datasetProprieteLocationMaisonIndisponible}
          dataset={datasetProprieteLocationMaison}
        />
      )}
      {typePeriodeFilter === "Maison en vente" && (
        <CompomentChildrenForStatistique
          dataSeries={[
            {
              dataKey: "maison_vente",
              label: "Enregistrés",
              valueFormatter: valueMoneyFormatter,
            },
          ]}
          dataSeriesIndisponible={[
            {
              dataKey: "maison_vente_indisponible",
              label: "Enregistrés",
              valueFormatter: valueMoneyFormatter,
            },
          ]}
          datasetIndisponible={datasetProprieteVenteMaisonIndisponible}
          dataset={datasetProprieteVenteMaison}
        />
      )}
      {typePeriodeFilter === "Terrain en vente" && (
        <CompomentChildrenForStatistique
          dataSeries={[
            {
              dataKey: "terrains",
              label: "Enregistrés",
              valueFormatter: valueMoneyFormatter,
            },
          ]}
          dataSeriesIndisponible={[
            {
              dataKey: "terrain_vente_indisponible",
              label: "Enregistrés",
              valueFormatter: valueMoneyFormatter,
            },
          ]}
          datasetIndisponible={datasetProprieteVenteTerrainIndisponible}
          dataset={datasetProprieteVenteTerrain}
        />
      )}
    </>
  );
}

const CompomentChildrenForStatistique = ({
  dataset,
  dataSeries,
  dataSeriesIndisponible,
  datasetIndisponible,
}) => {
  return (
    <AllStatistiqueBien
      titleStatitisque={"Biens disponibles"}
      titleStatitisqueDormant={"Biens Indisponibles"}
      dataSeriesIndisponible={dataSeriesIndisponible}
      datasetIndisponible={datasetIndisponible}
      dataSeries={dataSeries}
      dataset={dataset}
    />
  );
};
